import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
`

export const Header = styled.header`
  height: 3.25rem;
  background-color: ${(props) => props.theme.color.neutral.white};
  padding: 0.5rem;
  width: 100vw;
  display: flex;
  justify-content: center;
`

export const LogoContainer = styled.div`
  width: 70%;
`

export const Body = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
`

export const ImageBackground = styled.img`
  width: 100%;
  height: 25rem;
  object-fit: cover;
  justify-self: flex-start;
`

export const FormContainer = styled.div`
  background-color: ${(props) => props.theme.color.neutral.white};
  position: inherit;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -5rem;
  bottom: 0;
  border-radius: ${(props) => props.theme.border.radius};
  padding: 1.13rem 1.75rem;
  width: 80vw;
  white-space: pre-line;
  > h3 {
    color: #003e5f;
    font-weight: 550;
    font-size: clamp(1.5rem, 2vw, 2rem);
  }

  > h4 {
    color: #000000;
    font-weight: 550;
    font-size: clamp(1.25rem, 1.75vw, 1.75rem);
  }

  > h5 {
    color: #000000;
    font-weight: 500;
    font-size: clamp(1.125rem, 1.5vw, 1.5rem);
  }

  > p {
    color: #494949;
    font-size: clamp(1rem, 1.25vw, 1.25rem);
    line-height: clamp(1.25rem, 1.75vw, 1.75rem);

    > strong {
      color: #000;
      font-weight: 600;
    }
  }

  > ul > li {
    color: #494949;
    font-size: clamp(1rem, 1.25vw, 1.25rem);
    line-height: clamp(1.25rem, 1.75vw, 1.75rem);
  }
  > ul {
    list-style-position: inside; /* Keeps the list markers inside the ul */
    padding: 0; /* Removes default padding */
  }

  > span {
    color: #003e5f;
    font-size: clamp(1rem, 1.25vw, 1.25rem);
    line-height: clamp(1.25rem, 1.75vw, 1.75rem);
    font-weight: 600;
  }
`

export const FormTitle = styled.h2`
  letter-spacing: 0.00188rem;
  font-size: ${(props) => props.theme.font.textxl};
  font-weight: 500;
  margin: 1rem 0 1.5rem 0;
  color: ${(props) => props.theme.color.neutral.gray};
`

export const Form = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.12rem;

  &:required {
    border-color: ${(props) => props.theme.color.red.red600};
  }
`

export const FormRow = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;
`

export const FormCheckboxContainer = styled.div`
  display: flex;
  align-items: end;
  width: 50%;
  gap: 1rem;
  cursor: pointer;
`

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
`

interface CheckboxProps {
  isChecked: boolean
}

export const CheckboxAppearence = styled.label<CheckboxProps>`
  min-width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #cecece;
  background: #f7f7f7;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    display: ${(props) => (props.isChecked ? 'flex' : 'none')};
    filter: invert(75%) sepia(11%) saturate(6042%) hue- rotate(30deg)
      brightness(105%) contrast(68%);
  }
`

export const CheckboxLabel = styled.p`
  color: ${(props) => props.theme.color.neutral.gray};
  font-size: ${(props) => props.theme.font.textsm};
  letter-spacing: 0.00438rem;
`

export const FormTextArea = styled.textarea`
  border: none;
  overflow: auto;
  outline: none;
  box-shadow: none;
  resize: none;

  background-color: inherit;
  border: none;
  min-height: 10rem;
  width: 100%;
  word-wrap: soft;
  padding: 0.5rem;
  color: #494949;
`

export const FormButtonContainer = styled.div`
  width: 80%;
`

export const FooterContainer = styled.footer`
  width: 100%;
  background-color: #19235c;
  display: flex;
  padding: 3rem;
  justify-content: center;
  align-items: center;
  gap: 6rem;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`

export const FooterSection = styled.section`
  color: ${(props) => props.theme.color.neutral.white};
  display: flex;
  gap: 0.75rem;
  flex-direction: column;
`

export const FooterTitle = styled.h3`
  letter-spacing: 0.1rem;
  font-size: ${(props) => props.theme.font.textbase};
  font-weight: 400;
  cursor: default;
`

export const FooterInfos = styled.address`
  display: flex;
  gap: 0.6rem;
  flex-direction: column;
`

export const FooterLine = styled.div`
  display: flex;
  gap: 0.75rem;
  font-size: ${(props) => props.theme.font.textcaption};
  cursor: default;

  > svg {
    color: ${(props) => props.theme.color.blue.base};
  }
`

export const FooterSocialMediaIcon = styled.a`
  background-color: ${(props) => props.theme.color.neutral.white};
  color: ${(props) => props.theme.color.neutral.black};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;
  outline: none;
  text-decoration: none;
  cursor: pointer;
`

export const FooterMap = styled.div`
  position: relative;
  text-align: right;
  height: 165px;
  width: 600px;
`

export const FooterMapCanva = styled.div`
  overflow: hidden;
  background: none !important;
  height: 165px;
  width: 600px;
`
